export const GET_REGISTRANTS = "registrations/GET_REGISTRANTS";
export const UPDATE_REGISTRANTS = "registrations/UPDATE_REGISTRANTS";
export const DELETE_REGISTRANTS = "registrations/DELETE_REGISTRANTS";